import { render, staticRenderFns } from "./WAudioListNuevo.vue?vue&type=template&id=3c56aeed&scoped=true&"
import script from "./WAudioListNuevo.vue?vue&type=script&lang=js&"
export * from "./WAudioListNuevo.vue?vue&type=script&lang=js&"
import style0 from "./WAudioListNuevo.vue?vue&type=style&index=0&id=3c56aeed&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c56aeed",
  null
  
)

export default component.exports